import Vue from "vue";

function register(requireComponent) {
  requireComponent.keys().forEach(fileName => {
    // 获取组件配置
    const componentConfig = requireComponent(fileName);
    // 获取组件的 PascalCase 命名
    const componentName = fileName.replace(/^\.\/(.*)\.\w+$/, "$1"); // 剥去文件名开头的 `./` 和结尾的扩展名
    // 如果这个组件选项是通过 `export default` 导出的，
    // 那么就会优先使用 `.default`，
    // 否则回退到使用模块的根。
    const component = componentConfig.default || componentConfig;

    if (component.install) {
      Vue.use(component);
    } else {
      // 全局注册组件
      Vue.component(componentName, component);
    }
  });
}

const layouts = require.context(
  // 其组件目录的相对路径
  "../layouts",
  // 是否查询其子目录
  false,
  // 匹配基础组件文件名的正则表达式
  /\.vue$/
);

const globalComponents = require.context(
  // 其组件目录的相对路径
  "../components/Global",
  // 是否查询其子目录
  false,
  // 匹配基础组件文件名的正则表达式
  /\.(vue|js)$/
);

register(layouts);
register(globalComponents);
